import React from "react"
import PropTypes from "prop-types";
import Link from "../../Link";
import {
    AWSIconSolution,
    DEMIcon, FinaceIcon, FrontBackEnd, GamingIcon, GCPIconSolution, LogAnalysisIcon, MsAzureIcon, RetailECommerceIcon, TechnologyIcon, EndpointMonitoringIcon, KubernetesIconSolution
} from "../icons-header";
import { useTranslation } from "next-i18next";
import Image from "next/image";

const UseCaseDropdown = (props) => {
    const { t } = useTranslation("header");
    let dropdownItems = [
        {
            item1:[
                {
                    title:`${t('solutionsName.frontendBackendCorrelation')}`,
                    link:'/solutions/frontend-backend-correlation/',
                    icon:<FrontBackEnd/>,
                },
                {
                    title:`${t('solutionsName.digitalExperienceMonitoring')}`,
                    link:'/solutions/digital-experience-monitoring/',
                    icon:<DEMIcon/>,
                },
                {
                    title:`${t('solutionsName.logAnalysisCorrelation')}`,
                    link:'/solutions/log-analysis-correlation/',
                    icon:<LogAnalysisIcon/>,
                },
                {
                    title:`${t('solutionsName.endpointMonitoring')}`,
                    link:'/solutions/endpoint-monitoring/',
                    icon:<EndpointMonitoringIcon/>
                },
            ]
        },
    ]
    let dropdownItems1 = [
        {
            item2:[
                {
                    title:`${t('solutionsName.retailCommerce')}`,
                    link:'/solutions/retail/',
                    icon:<RetailECommerceIcon/>,
                },
                {
                    title:`${t('solutionsName.finance')}`,
                    link:'/solutions/finance/',
                    icon:<FinaceIcon/>,
                },
                {
                    title:`${t('solutionsName.gaming')}`,
                    link:'/solutions/gaming/',
                    icon:<GamingIcon/>,
                },
                {
                    title:`${t('solutionsName.technology')}`,
                    link:'/solutions/technology/',
                    icon:<TechnologyIcon/>,
                },

            ]
        },
    ]
    let dropdownItems2 = [
        {
            item3:[
                {
                    title:`${t('solutionsName.kubernetesMonitoring')}`,
                    link:'/solutions/kubernetes-monitoring/',
                    icon:<KubernetesIconSolution/>
                },
                {
                    title:`${t('solutionsName.awsMonitoring')}`,
                    link:'/solutions/aws/',
                    icon:<AWSIconSolution/>,
                },
                {
                    title:`${t('solutionsName.googleCloudPlatform')}`,
                    link:'/solutions/gcp/',
                    icon:<GCPIconSolution/>,
                },
                {
                    title:`${t('solutionsName.microsoftAzure')}`,
                    link:'/solutions/azure/',
                    icon:<MsAzureIcon/>,
                }

            ]
        },
    ]
    return <>
        <div className={'inner-wrapper product-menu solutions-menu'}>
            <div className={'d-flex sub-menu'}>
                <div className={'menus'}>
                    <div className={'d-flex'}>
                        {dropdownItems.map((mw_item, index) => {
                            return mw_item.item1 && Array.isArray(mw_item.item1) &&
                                <div className={'product-links'} key={index}>
                                    <div className={'product-drop'}>
                                        <p className={"menu-subHeading"}>Use cases</p>
                                        {mw_item.item1 && mw_item.item1.map((__item, __index) => {
                                            return <div key={__index}>
                                                {__item.link &&
                                                <Link href={__item.link} aria-label={'Middleware Dropdown'}
                                                              passHref>
                                                    <div className={'dropdown-menu'} onClick={props.onLinkClick}>
                                                            <span>{__item.icon}</span>
                                                            <div className="header-heading">

                                                                {__item.title}
                                                                {__item.isNew && <img src={"/images/product/new_features_dark.svg"} alt={"New Feature"} width={100} height={100} className={"new_features"}/>}
                                                            </div>
                                                    </div>
                                                </Link>
                                                }
                                            </div>
                                        })}
                                    </div>
                                </div>


                        })}
                        {dropdownItems1.map((item1, index) => {
                            return item1.item2 && Array.isArray(item1.item2) &&
                                <div className={'product-links'} key={index}>
                                    <div className={'product-drop'}>
                                        <p className={"menu-subHeading"}>Industries</p>
                                        {item1.item2 && item1.item2.map((__item, __index) => {
                                            return <div key={__index}>
                                                {__item.link &&
                                                <Link href={__item.link} aria-label={'Middleware Dropdown'}
                                                              passHref>
                                                    <div className={'dropdown-menu'} onClick={props.onLinkClick}>
                                                            <span>{__item.icon}</span>
                                                            <div className="header-heading">
                                                                {__item.title}
                                                            </div>
                                                        </div>
                                                </Link>}
                                            </div>
                                        })}
                                    </div>
                                </div>
                        })
                        }
                        {dropdownItems2.map((item, index) => {
                            return item.item3 && Array.isArray(item.item3) &&
                                <div className={'product-links'} key={index}>
                                    <div className={'product-drop'}>
                                        <p className={"menu-subHeading"}>Technology</p>
                                        {item.item3 && item.item3.map((__item, __index) => {
                                            return <div key={__index}>
                                                {__item.link &&
                                                <Link href={__item.link} aria-label={'Middleware Dropdown'}
                                                              passHref>
                                                    <div className={'dropdown-menu'} onClick={props.onLinkClick}>
                                                            <span>{__item.icon}</span>
                                                            <div className="header-heading">
                                                                {__item.title}
                                                                {__item.beta &&
                                                                    <span className={'beta'}>{__item.beta}</span>}
                                                                {__item.isNew && <img src={"/images/product/new_features_dark.svg"} alt={"New Feature"} width={100} height={100} className={"new_features"}/>}
                                                            </div>

                                                        </div>
                                                </Link>}
                                            </div>
                                        })}
                                    </div>
                                </div>
                        })
                        }
                    </div>
                </div>
                <div className={"menu-cta solution-page-menu"}>
                    <p className="top-heading">Customer Proof</p>
                    <p className="customer-quots">Middleware reduced the time spent debugging and resolving issues by nearly 90%.</p>

                    <div className="customer-auth">
                        Nico Laqua, CEO at Corgi
                    </div>

                    <Image src={"/images/solution-menu-img.svg"} alt="Solution Review" width={100} height={100} />

                    <Link key={"mw-register"} href={'/customers/'} className={'sign-up ahref-btn primary'} aria-label={'Middleware Register'} passHref prefetch={false}>{t('logInSignUp.customerStorys')}</Link>
                </div>
            </div>
        </div>
    </>
}
UseCaseDropdown.propTypes = {
    pageID: PropTypes.number,
    onLinkClick: PropTypes.any
}
export default UseCaseDropdown